import { ActionReturnType, FilterActionTypes } from './filters.actions'
import { FiltersContextState } from './filters.type'

export function FilterReducer(state: FiltersContextState, action: ActionReturnType): FiltersContextState {
  const { payload, type } = action
  switch (type) {
    case FilterActionTypes.setReservationMoveOutRange: {
      const { reservationMoveOutRange } = payload
      return {
        ...state,
        reservationMoveOutRange: {
          ...state.reservationMoveOutRange,
          ...reservationMoveOutRange,
        },
      }
    }
    case FilterActionTypes.setReservationMoveInRange: {
      const { reservationMoveInRange } = payload
      return {
        ...state,
        reservationMoveInRange: {
          ...state.reservationMoveInRange,
          ...reservationMoveInRange,
        },
      }
    }
    default: {
      if (payload) {
        return { ...state, ...payload }
      }
      return { ...state }
    }
  }
}
